import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  Box,
  Paper,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

const UserResetSuccessDialog = ({ open, username, password, onClose }) => {
  const dialogPaperSx = {
    borderRadius: "18px",
    background: "rgba(255,255,255,0.96)",
    backdropFilter: "blur(10px)",
    boxShadow: "0 20px 60px rgba(0,0,0,0.25)",
    overflow: "hidden",
  };

  const primaryButtonSx = {
    backgroundColor: "#2f63ad",
    color: "white",
    fontWeight: 700,
    borderRadius: "10px",
    textTransform: "none",
    px: 3,
    boxShadow: "none",
    "&:hover": {
      backgroundColor: "#1f4f94",
      boxShadow: "none",
    },
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{ sx: dialogPaperSx }}
    >
      <DialogTitle
        sx={{
          textAlign: "center",
          fontWeight: 700,
          fontSize: "1.3rem",
          pt: 3,
          pb: 1,
        }}
      >
        Password Reset Successful
      </DialogTitle>

      <DialogContent sx={{ textAlign: "center", px: 3 }}>
        <Box sx={{ display: "flex", justifyContent: "center", mb: 1.5 }}>
          <CheckCircleIcon sx={{ fontSize: 42, color: "#10b981" }} />
        </Box>

        <Typography sx={{ color: "#444", fontSize: "0.95rem" }}>
          A new password has been generated for
        </Typography>

        <Typography
          sx={{
            fontWeight: 700,
            mt: 0.5,
            color: "#223142",
          }}
        >
          {username}
        </Typography>

        <Box sx={{ mt: 2 }}>
          <Typography
            sx={{
              fontSize: "0.85rem",
              color: "#777",
              mb: 0.5,
            }}
          >
            Temporary Password
          </Typography>

          <Paper
            elevation={0}
            sx={{
              p: 1.2,
              borderRadius: "10px",
              backgroundColor: "#f5f7fa",
              border: "1px solid #e0e6ed",
              fontFamily: "monospace",
              fontWeight: 600,
              fontSize: "0.95rem",
              userSelect: "all",
            }}
          >
            {password}
          </Paper>
        </Box>
      </DialogContent>

      <DialogActions
        sx={{
          justifyContent: "center",
          pb: 3,
          pt: 2,
        }}
      >
        <Button onClick={onClose} variant="contained" sx={primaryButtonSx}>
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UserResetSuccessDialog;
